import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import OrLabel from './OrLabel'

interface SamlButtonProps {
  idpName: string
  className: string
  loading: boolean
  onClick: () => void
}

interface SamlButtonsProps {
  samlProviders: SamlProvider[]
  className: string
  buttonClassName: string
  loading: boolean
  includeOrLabel: boolean
  onSamlSubmit: (samlId: string) => void
}

const SamlButton: FC<SamlButtonProps> = ({
  idpName,
  className,
  loading,
  onClick,
}) => {
  return (
    <div className={className}>
      <Button
        isLoading={loading}
        disabled={loading}
        id="saml-submit"
        size="regular"
        type="button"
        variation="primary"
        onClick={onClick}
        block
        inline={false}
      >
        <FormattedMessage id="loginProviderLabel" />
        <span className="ml2">{idpName}</span>
      </Button>
    </div>
  )
}

const SamlButtons: FC<SamlButtonsProps> = ({
  samlProviders,
  className,
  buttonClassName,
  loading,
  onSamlSubmit,
  includeOrLabel,
}: SamlButtonsProps) => {
  return (
    <div className={`f6 truncate ${className}`}>
      {samlProviders.map(
        (saml: SamlProvider) =>
          saml && (
            <SamlButton
              key={saml.id}
              idpName={saml.idpName}
              className={buttonClassName}
              loading={loading}
              onClick={() => onSamlSubmit(saml.id)}
            />
          )
      )}
      {/* // TODO: this error popped up when moving the checkout-instore project
      // to checkout-instore-legacy, but needs to be fixed at some point
      // @ts-ignore */}
      {includeOrLabel && <OrLabel className="mt3" />}
    </div>
  )
}

export default SamlButtons
